import { cva } from 'class-variance-authority';

export { default as CreditSimulator } from './CreditSimulator.vue';

export const creditSimulatorFieldVariants = cva(
	'rounded-xs bg-black text-[#FAFAFA]',
	{
		variants: {
			variant: {
				value: 'min-h-11 px-2.5 py-1.5 text-right text-[17px] font-medium',
				text: 'min-h-[50px] px-3.5 text-[16px] placeholder:text-[#6E6E6E]'
			},
			invalid: {
				true: 'border-2 border-[#FF8A7A]',
				false: 'border border-[#3A3A3A]'
			}
		},
		defaultVariants: { invalid: false }
	}
);

export const creditSimulatorButtonVariants = cva(
	'rounded-xs font-medium cursor-pointer',
	{
		variants: {
			variant: {
				primary: 'flex-1 min-h-13 border-none bg-beige text-black text-[16px]',
				back: 'min-h-13 px-5 border border-[#3A3A3A] bg-black text-[#FAFAFA] text-[15px]'
			}
		}
	}
);

export const creditSimulatorChoiceVariants = cva(
	'min-h-11 rounded-xs text-[14px] font-medium cursor-pointer',
	{
		variants: {
			kind: {
				tab: 'border-none',
				option: 'px-4 border'
			},
			selected: { true: 'bg-[#FAFAFA] text-black', false: '' }
		},
		compoundVariants: [
			{ kind: 'tab', selected: false, class: 'bg-transparent text-[#A3A3A3]' },
			{ kind: 'option', selected: true, class: 'border-[#FAFAFA]' },
			{
				kind: 'option',
				selected: false,
				class: 'bg-black text-[#FAFAFA] border-[#3A3A3A]'
			}
		]
	}
);
